module.exports = __webpack_public_path__ + "static/media/6.46a730af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/carousel/6.jpg
// module id = 663
// module chunks = 6